export default "__VITE_ASSET__FJaTcs9U__"